/** * This component * - Abstracts an external library implementation of a Select-style input. * -
Applies universal form styling & reasonable defaults. */

<script setup lang="ts">
import Select from "primevue/select";
import { ref, useId } from "vue";

import {
  useSingleResultFilterEnter,
  type SelectSingleResultSurface,
} from "@/composables/useSingleResultFilterEnter";

const selectRef = ref<InstanceType<typeof Select> | null>(null);
useSingleResultFilterEnter(() => selectRef.value as unknown as SelectSingleResultSurface | null);
</script>

<template>
  <Select
    ref="selectRef"
    :inputId="`dropdown-${useId()}`"
    :autoFilterFocus="true"
    :filter="true"
    v-bind="$attrs"
  >
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </Select>
</template>

<style lang="postcss" scoped></style>
